import React from 'react'
import { Link } from 'react-router'

function LoginFooter() {
    return (
        <div className="container login-footer py-5">
            <div className="d-flex flex-lg-row flex-column justify-content-between w-100 align-items-center">
                <div className="d-flex">
                    <Link to=''> Home</Link>
                    <Link to=''>Whitepaper</Link>
                    <Link to=''>Forus Community</Link>
                    <Link to=''>News</Link>
                    <Link to=''>Contact</Link>
                </div>
                <span style={{opacity:".5"}}>
                    Copyright 2022 forus . All Rights Reserved
                </span>
            </div>
        </div>
    )
}

export default LoginFooter